<template>
  <div>
    <h1 class="m-label" style="margin: 0">先生一覧</h1>
    <div class="m-box__inner2">

      <transition name="loading" mode="out-in">
        <template v-if="student.student_tutors">

          <ul class="m-List">
            <li class="m-Item" v-for="(list, index) in mapStudent_tutors" :key="index.id">

              <template v-if="edit_id.edit_id !== list.id">
                <template v-if="list.tutor">

                  <div class="m-Item__block" v-bind:class="{ unknown: list.tutor.gender === 0, boy: list.tutor.gender === 1, girl: list.tutor.gender === 2 }">
                    <div class="m-Item__content" v-bind:class="{ gray: new Date(Date.parse(list.guidance_period_end)) < new Date() }">
                      <i class="fa fa-graduation-cap"></i>
                      <div>{{list.tutor.f_name}} {{list.tutor.l_name}}
                      ({{list.tutor.f_name_kana}} {{list.tutor.l_name_kana}})</div>
                      <div>
                        {{list.tutor.school_name}}
                        {{list.tutor.grade}}
                        {{list.tutor.department}}
                        <!-- {{list.tutor.grade}} -->
                      </div>
                      <!-- <div>{{list.mapGuidance_period_start}} ~ {{list.mapGuidance_period_end}}</div> -->
                      <div>{{list.guidance_period_start}} ~ {{list.guidance_period_end}}</div>
                      <div>{{list.note}}</div>
                    </div>
                    <div class="m-Item__content2">
                      <btn class="jump" @click.native="linkTutor(list)"><i class="fa fa-address-card"></i></btn>
                      <btn class="jump" @click.native="edit(list)">編集</btn>
                      <btn class="delete" @click.native="deleteStudentTutor(list)"><i class="fa fa-trash"></i></btn>
                    </div>
                  </div>

                </template>

                <template v-else>
                  <div class="m-Item__block">
                      <div class="m-Item__content">
                      <template v-if="list.state === 0"><div></div></template>
                      <template v-if="list.state === 1"><div>探し中</div></template>
                      <template v-if="list.state === 2"><div>研修待ち</div></template>
                      <template v-if="list.state === 3"><div>紹介待ち</div></template>
                      <template v-if="list.state === 4"><div>初回日待ち</div></template>
                      <template v-if="list.state === 5"><div>探しcomplete</div></template>
                      <template v-if="list.state === 6"><div>探しcancel</div></template>
                    </div>
                    <div class="m-Item__content2">
                      <btn class="jump" @click.native="linkStudentTutors"><i class="fa fa-address-card"></i></btn>
                      <btn class="delete" @click.native="deleteStudentTutor(list)"><i class="fa fa-trash"></i></btn>
                    </div>
                  </div>
                </template>
              </template>

              <template v-if="edit_id.edit_id === list.id">
                <template v-if="list.tutor">

                  <div class="m-Item__block" v-bind:class="{ unknown: list.tutor.gender === 0, boy: list.tutor.gender === 1, girl: list.tutor.gender === 2 }">
                    <div class="m-Item__content" v-bind:class="{ gray: new Date(Date.parse(list.guidance_period_end)) < new Date() }">
                      <i class="fa fa-graduation-cap"></i>
                      <div>{{list.tutor.f_name}} {{list.tutor.l_name}}
                      ({{list.tutor.f_name_kana}} {{list.tutor.l_name_kana}})</div>
                      <div>
                        {{list.tutor.school_name}}
                        {{list.tutor.grade}}
                        {{list.tutor.department}}
                        <!-- {{list.tutor.grade}} -->
                      </div>
                      <div>
                        <!-- <input type="text" v&#45;model="list.mapGuidance_period_start"> -->
                        <input type="text" v-model="list.guidance_period_start">
                        <!-- <input type="text" v&#45;model="list.mapGuidance_period_end"> -->
                        <input type="text" v-model="list.guidance_period_end">
                      </div>
                      {{list.note}}
                    </div>
                    <div class="m-Item__content2">
                      <btn class="jump" @click.native="linkTutor(list)"><i class="fa fa-address-card"></i></btn>
                      <btn class="jump" @click.native="patchStudent_tutor(list)">更新</btn>
                      <btn class="jump" @click.native="cancelStudent_tutor">戻る</btn>
                      <btn class="delete" @click.native="deleteStudentTutor(list)"><i class="fa fa-trash"></i></btn>
                    </div>
                  </div>

                </template>

                <template v-else>

                  <div class="m-Item__block">
                      <div class="m-Item__content">
                      <i class="fa fa-graduation-cap"></i>
                      <template v-if="list.state === 0"><div></div></template>
                      <template v-if="list.state === 1"><div>探し中</div></template>
                      <template v-if="list.state === 2"><div>研修待ち</div></template>
                      <template v-if="list.state === 3"><div>紹介待ち</div></template>
                      <template v-if="list.state === 4"><div>初回日待ち</div></template>
                      <template v-if="list.state === 5"><div>complete</div></template>
                    </div>
                    <div class="m-Item__content2">
                      <btn class="jump" @click.native="linkStudentTutors"><i class="fa fa-address-card"></i></btn>
                      <btn class="delete" @click.native="deleteStudentTutor(list)"><i class="fa fa-trash"></i></btn>
                    </div>
                  </div>

                </template>

              </template>

            </li>
          </ul>

        </template>
        <template v-else>
          <loading></loading>
        </template>
      </transition>

    </div>
    <router-link to="/student_tutors"><btn style="border-left: solid 1px #ccc; border-right: solid 1px #ccc">探しデータ</btn></router-link>
  </div>
</template>

<script>
let _ = window._
export default {
  props: {
    student: Object
  },
  name: 'StudentTutorsIndex',
  data () {
    return {
      edit_id: {
        edit_id: ''
      }
        // filing_date: '',
        // matching_type: '',
        // change_reason: '',
        // matching_month: '',
        // matching_date: '',
        // student_id: '',
        // tutor_id: '',
        // note: '',
        // guidance_period_start: '',
        // guidance_period_end: '',
    }
  },
  watch: {
  },
  computed: {
    // order By
    orderedStudent_tutors () {
      return _.orderBy(this.student.student_tutors, 'guidance_period_end', 'desc')
    },

    // map
    mapStudent_tutors () {
      let self = this
      return self.orderedStudent_tutors.map((student_tutor) => {
        // student_tutor.mapGuidance_period_start = self.calcDateTime(student_tutor.guidance_period_start)
        student_tutor.guidance_period_start = self.calcGuidance_period_start(student_tutor.guidance_period_start)
        // student_tutor.mapGuidance_period_end = self.calcDateTime(student_tutor.guidance_period_end)
        student_tutor.guidance_period_end = self.calcGuidance_period_end(student_tutor.guidance_period_end)
        return student_tutor
      })
    }
  },
  methods: {
    calcDateTime (val) {
      const datetime = new Date(val)
      const year = datetime.getFullYear()
      let month = datetime.getMonth() + 1
      month = month.toString()
      month = month.padStart(2, '0')
      let date = datetime.getDate()
      date = date.toString()
      date = date.padStart(2, '0')
      let hours = datetime.getHours()
      hours = hours.toString()
      hours = hours.padStart(2, '0')
      let minutes = datetime.getMinutes()
      minutes = minutes.toString()
      minutes = minutes.padStart(2, '0')
      return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes
    },

    calcGuidance_period_start (guidance_period_start) {
      if (!guidance_period_start) {
        return
      }
      let date = guidance_period_start.substring(0, 10)
      let time = guidance_period_start.substring(11, 16)
      let datetime = date + ' ' + time
      return datetime
    },

    calcGuidance_period_end (guidance_period_end) {
      if (!guidance_period_end) {
        return
      }
      let date = guidance_period_end.substring(0, 10)
      // let time = guidance_period_end.substring(11, 16)
      let datetime = date
      return datetime
    },

    edit (list) {
      this.edit_id.edit_id = list.id
    },

    linkStudentTutors () {
      if (window.confirm('探しデータに移動しますか？')) {
        this.$router.push({ path: '/student_tutors', exact: true })
      } else {
        return
      }
    },

    linkTutor (list) {
      this.$router.push({ name: 'tutorindex', params: { id: list.tutor_id }, exact: true })
    },

    deleteStudentTutor (list) {
      this.$store.dispatch('deleteStudentTutor', list)
    },

    cancelStudent_tutor () {
      this.$store.dispatch('cancelStudent_tutor', {
        this: this,
        edit_id: this.edit_id
      })
    },

    patchStudent_tutor (list) {
      this.$store.dispatch('patchStudent_tutor', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.unknown {
  border-left: solid 3px #000000;
  .m-Item__content {
    .fa-graduation-cap {
      color: #000000;
    }
  }
}
.boy {
  border-left: solid 3px #3F51B5;
  .m-Item__content {
    .fa-graduation-cap {
      color: #3F51B5;
    }
  }
}
.girl {
  border-left: solid 3px #E91E63;
  .m-Item__content {
    .fa-graduation-cap {
      color: #E91E63;
    }
  }
}
.gray {
  background: #dddddd;
}
.m-List {
  list-style-type: none;
  margin:0;
  padding:0;
}
.m-Item {
  border: 1px solid #eee;
  position: relative;
  .fa-graduation-cap {
    font-size: 50px;
    margin-bottom: 5px;
  }
  &__block {
    word-wrap: break-word;
    display: flex;
    .m-Item__content {
      flex-grow: 1;
      width: 85%;
      padding: 1em;
    }
    .m-Item__content2 {
      flex-grow: 1;
      width: 30px;
      display: flex;
      flex-flow: column nowrap;
      .jump {
        /* background: #37474F; */
        margin: 0;
        flex-grow: 3;
        padding: 0;
      }
      .delete {
        background: #546E7A;
        margin: 0;
        flex-grow: 1;
        padding: 0;
      }
    }
  }
}
.m-box__inner2 {
  height: calc(100vh - 262px);
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// StudentTutorsIndex.vue?afe834ec